var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatMessageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.92656 19.9477H8.40156C4.20156 19.9477 2.10156 18.8977 2.10156 13.6477V8.39766C2.10156 4.19766 4.20156 2.09766 8.40156 2.09766H16.8016C21.0016 2.09766 23.1016 4.19766 23.1016 8.39766V13.6477C23.1016 17.8477 21.0016 19.9477 16.8016 19.9477H16.2766C15.9511 19.9477 15.6361 20.1052 15.4366 20.3677L13.8616 22.4677C13.1686 23.3917 12.0346 23.3917 11.3416 22.4677L9.76656 20.3677C9.59856 20.1367 9.21006 19.9477 8.92656 19.9477Z",
    stroke: "#1B3664",
    strokeWidth: 2.25,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8005 11.5523H16.8099",
    stroke: "#1B3664",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5895 11.5523H12.599",
    stroke: "#1B3664",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.39423 11.5523H8.40366",
    stroke: "#1B3664",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMessageIcon);
export default __webpack_public_path__ + "static/media/ChatMessageIcon.f57931e70e5847b4d6dc46cd54783955.svg";
export { ForwardRef as ReactComponent };